// EditCategoryModal.js
import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Select,notification } from 'antd';
import { CloseCircleOutlined } from '@ant-design/icons';
const { Option } = Select;
const EditOffer = ({
  category,
  show,
  onHide,
  onSave,
  isLoadingEdit,
  editChitDetails,
  fetchData
}) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  // Define state variables for form fields
  const [companycategory, setCompanycategory] = useState(category.companycategory);

  const handleSaveChanges = async () => {
    // Create an object with the updated values
    const updatedCategory = {
        companycategoryid: category.companycategoryid, // Include the category ID for identification
      companycategory,
    };
  
    try {
      const confirmed = window.confirm("Are you sure you want to save changes?");
      if (!confirmed) {
        // If the user cancels, do nothing
        return;
      }
      setLoading(true);
  
      // Make an API request to update the category without uploading the image
      const response = await axios.post(
        "https://api.nagaratharcoc.com/api/v1/companycategory/edit",
        updatedCategory,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
            "Content-Type": "application/json",
          },
        }
      );
  
      if (response.status === 401 || response.status === 404) {
        navigate("/AdminLogin");
        return;
      }
  
      if (response.data.success) {
        console.log("Category updated successfully");
        onSave(updatedCategory); // Notify the parent component about the update
      } else {
        console.error("Failed to update category");
      }
  
      setLoading(false);
      notification.success({
        message: response.data.description,
      });
      onHide(); // Close the modal
      fetchData();
      
    } catch (error) {
      console.error("Error updating category:", error);
      setLoading(false);
    }
  };
  
    

  return (
    <Modal show={show} onHide={onHide}>
      {/* Modal content */}
      <Modal.Header closeButton>
        <Modal.Title>Edit Business Category</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId="categoryname">
            <Form.Label>Company Category</Form.Label>
            <Form.Control
              type="text"
              name="categoryname"
              value={companycategory}
              onChange={(e) => setCompanycategory(e.target.value)}
            />
          </Form.Group>

        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
        <Button variant="primary" onClick={handleSaveChanges} disabled={loading}>
          Save Changes
        </Button>
        
      </Modal.Footer>
    </Modal>
  );
};

export default EditOffer;
